import Vue from 'vue';
import { COMMON_BUS_COMPONENTS_LIST } from '@/constants/commonBusComponentsList';
import { mapGetters } from 'vuex';
import applyPageI18NMessages from '@/vue-utils/i18n';
export default Vue.extend({
    data: () => ({
        path: ''
    }),
    computed: Object.assign({}, mapGetters('mainPageModules', ['getSocketsLoading'])),
    created() {
        const vm = this;
        const componentName = this.$route.query.component;
        let positions = localStorage.getItem('widgetsPositions');
        if (!positions)
            positions = {};
        let oldX = window.screenX;
        let oldY = window.screenY;
        if (!positions[componentName])
            positions[componentName] = {};
        setInterval(function () {
            if (oldX !== window.screenX || oldY !== window.screenY) {
                positions[componentName].x = window.screenX;
                positions[componentName].y = window.screenY;
                if (!vm.$isElectron) {
                    window.dispatchEvent(new CustomEvent('windowmoved', { detail: positions }));
                }
                else {
                    const { app } = require('electron').remote;
                    app.emit('windowmoved', Object.assign({}, positions));
                }
            }
            oldX = window.screenX;
            oldY = window.screenY;
        }, 3000);
        const componentInfo = COMMON_BUS_COMPONENTS_LIST.find(item => item.name === componentName);
        if (componentInfo) {
            vm.path = componentName;
            componentInfo.translation().then(translation => {
                applyPageI18NMessages(this, componentInfo.translationName, translation);
            });
            document.title = componentInfo.title;
        }
        else {
            vm.$router.replace({ name: 'errorPage' });
        }
        vm.$commonBus.mainState.components[componentName].dropped = true;
        if (!vm.getSocketsLoading) {
            vm.$store.dispatch('mainPageModules/loadSockets');
        }
    },
    beforeCreate() {
        document.body.classList.add('isGateway');
    },
    components: {
        mainPagePositions: () => import('@/components/pages/mainPage/tables/positions.vue'),
        mainPageBids: () => import('@/components/pages/mainPage/tables/bids.vue'),
        spotPage: () => import('@/components/pages/spotPage/trade/index.vue'),
        currencyWallet: () => import('@/components/pages/mainPage/sidebar/items/currencyWallet.vue'),
        spotWallet: () => import('@/components/pages/mainPage/sidebar/items/spotWallet.vue'),
        internalTransfers: () => import('@/components/pages/mainPage/sidebar/items/internalTransfers.vue'),
        leveragesPage: () => import('@/components/pages/leveragesPage/index.vue'),
        whitelists: () => import('@/components/pages/whitelists/main/index.vue'),
        outboundTransfers: () => import('@/components/pages/transfersPage/components/sidebar/outbound/index.vue'),
        inboundTransfers: () => import('@/components/pages/transfersPage/components/sidebar/inbound/index.vue')
    }
});
